export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-pinterest-fb1cefe22e73bfc86a159c409eee3927.svg";